'use strict';

var _classCallCheck = require("/codebuild/output/src977441055/src/ibrd/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src977441055/src/ibrd/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RNG = exports.CHARSET = exports.HASH_LENGTH = exports.CharsetLengthError = exports.RandomHash = exports.generateHash = undefined;

var _crypto = require('crypto');

var _baseN = require('./baseN');

var HASH_LENGTH = 6;
var CHARSET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_';
var RNG = _crypto.randomBytes;

function _generateHash() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$length = options.length,
      hashLength = _options$length === void 0 ? HASH_LENGTH : _options$length,
      _options$charset = options.charset,
      charset = _options$charset === void 0 ? CHARSET : _options$charset,
      _options$rng = options.rng,
      rng = _options$rng === void 0 ? RNG : _options$rng;
  var numBytes = Math.ceil(hashLength * (0, _baseN.charLength)(charset) / 8);
  var bytes = rng(numBytes);
  var encode = (0, _baseN.createEncoding)(charset);
  var hash = encode(bytes);
  hash = hash.slice(0, hashLength);
  return hash.join('');
}

var RandomHash =
/*#__PURE__*/
function () {
  function RandomHash() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RandomHash);

    var length = options.length,
        charset = options.charset,
        rng = options.rng;
    this.hashLength = length || HASH_LENGTH;
    this.charset = charset || CHARSET;
    this.rng = rng || RNG;
    (0, _baseN.charLength)(this.charset);
    this.generateHash = this.generateHash.bind(this);
    var instance = this;
    Object.defineProperty(this.generateHash, 'length', {
      get: function get() {
        return instance.hashLength;
      },
      set: function set(newHashLength) {
        instance.hashLength = newHashLength;
      }
    });
    Object.defineProperty(this.generateHash, 'charset', {
      get: function get() {
        return instance.charset;
      },
      set: function set(newCharset) {
        (0, _baseN.charLength)(newCharset);
        instance.charset = newCharset;
      }
    });
    Object.defineProperty(this.generateHash, 'rng', {
      get: function get() {
        return instance.rng;
      },
      set: function set(newRng) {
        instance.rng = newRng;
      }
    });
    Object.setPrototypeOf(this.generateHash, this.constructor.prototype);
    return this.generateHash;
  }

  _createClass(RandomHash, [{
    key: "generateHash",
    value: function generateHash() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$length2 = options.length,
          length = _options$length2 === void 0 ? this.hashLength : _options$length2,
          _options$charset2 = options.charset,
          charset = _options$charset2 === void 0 ? this.charset : _options$charset2,
          _options$rng2 = options.rng,
          rng = _options$rng2 === void 0 ? this.rng : _options$rng2;
      return _generateHash({
        length: length,
        charset: charset,
        rng: rng
      });
    }
  }]);

  return RandomHash;
}();

exports.default = _generateHash;
exports.generateHash = _generateHash;
exports.RandomHash = RandomHash;
exports.CharsetLengthError = _baseN.CharsetLengthError;
exports.HASH_LENGTH = HASH_LENGTH;
exports.CHARSET = CHARSET;
exports.RNG = RNG;